export default __webpack_public_path__ + "static/media/icon-heart-filled.fd992843.svg";